import _ from "lodash";
import React from "react";

import Prompt from "../Prompt";
import { getUpdatedPrompts } from "ClassRoom/components/AddAssignment/LessonPlanningAssistant/modules/Utils";

import classes from "./SuggestedPrompts.scss";

const SuggestedPrompts = props => {
  const {
    t,
    prompts,
    selectedPrompt,
    onSelectedPromptChange,
    language,
    resolvedSubjectGroupNodes,
  } = props;

  const updatedPrompts = getUpdatedPrompts({
    t,
    value: prompts,
    subjectGroups: resolvedSubjectGroupNodes,
    isEnglishLanguageSelected: language === "en",
  });

  return (
    <div className={classes.container}>
      {_.map(updatedPrompts, prompt => (
        <Prompt
          t={t}
          prompt={prompt}
          selectedPrompt={selectedPrompt}
          onSelectedPromptChange={onSelectedPromptChange}
          language={language}
        />
      ))}
    </div>
  );
};

export default SuggestedPrompts;
